export default __webpack_public_path__ + "static/media/camera-icon.63976408.svg";